<!-- Top Bar -->
<div
  class="global__top-bar__height d-flex align-items-center fs-18px font-weight-bold pl-15px border-bottom border-color-grey"
>
  <top-bar-mobile-hamburger-menu
    class="mr-15px d-lg-none"
  ></top-bar-mobile-hamburger-menu>

  <i class="far fa-check-circle text-primary"></i>
  &nbsp;Buy Complete
</div>

<div class="fs-15px px-15px pt-25px pb-30px">
  <div class="font-weight-bold fs-24px mb-15px">
    New balance:
    {{ globalVars.nanosToDeSo(globalVars.loggedInUser.BalanceNanos, 9) }} $DESO
  </div>

  <a
    class="link--unstyled text-primary font-weight-bold"
    [routerLink]="'/' + globalVars.RouteNames.CREATORS"
    queryParamsHandling="merge"
  >
    Buy creator coins »
  </a>

  <div class="text-grey7 mt-15px">
    Use $DESO to buy creator coins. Collect your favorite creators and get on
    their team!
  </div>
</div>

<div class="w-100 border-top border-color-grey text-grey5 mt-10px">
  <div
    class="fs-15px buy-deso__box-label-adjustment pl-5px pr-5px ml-10px"
    style="background-color: white"
  >
    Next
  </div>
</div>

<div class="ml-15px">
  <div class="mt-10px">
    <a
      class="link--unstyled text-grey5"
      [routerLink]="'/' + globalVars.RouteNames.WALLET"
      queryParamsHandling="merge"
    >
      View your wallet »
    </a>
  </div>

  <div class="mt-15px">
    <a
      class="link--unstyled text-grey5"
      [routerLink]="'/' + globalVars.RouteNames.UPDATE_PROFILE"
      queryParamsHandling="merge"
    >
      Update your profile »
    </a>
  </div>

  <div class="mt-15px">
    <a
      class="link--unstyled text-grey5"
      [routerLink]="'/' + globalVars.RouteNames.BUY_DESO"
      (click)="triggerBuyMoreDeSo()"
      queryParamsHandling="merge"
    >
      Buy more $DESO »
    </a>
  </div>
</div>
